import { ehProvedorTelmex } from '@/common/helpers/ProvedorTelmex';

const usuarioLogado = (state) => {
    return state.login;
}

const logando = (state) => {
    return state.logando;
}

const isProvedorTelmex = (state) => {
    return ehProvedorTelmex(state.login.ctrl_provedores);
}

export {
    usuarioLogado,
    logando,
    isProvedorTelmex
}